import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IoMdNotificationsOutline } from "react-icons/io";
import { BsInboxes } from "react-icons/bs";
import { BsGear } from "react-icons/bs";
import logo from "./images/ClowdsIcon.png";
// let userDataName = localStorage.getItem("userDataName");

const Profile = () => {
  let userData = JSON.parse(localStorage.getItem("userData"));
  console.log("User", userData);
  let walletType = userData?.walletType;
  useEffect(() => {
    return () => {
      console.log("State Updated");
      let userData = JSON.parse(localStorage.getItem("userData"));
    };
  }, [localStorage.getItem("userData")]);

  return (
    <div id="menu" className="bg-[#151c2c] col-span-3 rounded-lg p-4 ">
      <h1 className="font-bold text-lg lg:text-3xl bg-gradient-to-br from-white via-white/50 to-transparent bg-clip-text text-transparent">
        Creator <span className="text-indigo-400"></span>
      </h1>
      <p className="text-slate-400 text-sm mb-2">Welcome back,</p>
      <div className="flex flex-col space-y-2 md:space-y-0 md:flex-row items-center md:space-x-2 hover:bg-white/10 group transition duration-150 ease-linear rounded-lg group w-full py-3 px-2">
        <div>
          <img
            className="rounded-full w-10 h-10 mx-auto relative object-cover"
            src={logo}
            alt=""
          />
        </div>
        <div className="font-bold text-base uppercase text-slate-400">
          {userData?.name}
        </div>
      </div>
      <div className="px-2 hidden sm:block break-words font-bold text-sm mb-5 text-slate-400">
        {userData?.email}
      </div>

      <hr className="my-2 border-slate-700" />
      <div id="menu" className="flex flex-col space-y-2 my-5">
        <Link to="/creator">
          <div className="hover:bg-white/10 transition duration-150 ease-linear rounded-lg py-3 px-2 group">
            <div className="flex flex-col space-y-2 md:flex-row md:space-y-0 space-x-2 items-center">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-6 h-6 group-hover:text-indigo-400"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                  />
                </svg>
              </div>
              <div>
                <p className="font-bold text-base lg:text-lg text-slate-200 leading-4 group-hover:text-indigo-400">
                  Dashboard
                </p>
                <p className="text-slate-400 text-sm hidden md:block">
                  Data overview
                </p>
              </div>
            </div>
          </div>
        </Link>
        <Link to="/requests">
          <div className="hover:bg-white/10 transition duration-150 ease-linear rounded-lg py-3 px-2 group">
            <div
              // data-dropdown-toggle="dropdown"
              id="dropdownDefaultButton"
              className="relative flex hover:cursor-pointer flex-col space-y-2 md:flex-row md:space-y-0 space-x-2 items-center"
            >
              <div>
                <IoMdNotificationsOutline
                  size={30}
                  className="w-6 h-6 group-hover:text-indigo-400"
                />
              </div>
              <div>
                <p className="font-bold hover:cursor-pointer text-base lg:text-lg text-slate-200 leading-4 group-hover:text-indigo-400">
                  Notifications
                </p>
                <p className="text-slate-400 text-sm hidden md:block">
                  Access Requests
                </p>
                {/* <div
                id="dropdown"
                className="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700"
              >
                <ul
                  className="py-2 text-sm text-gray-700 dark:text-gray-200"
                  aria-labelledby="dropdownDefaultButton"
                >
                  <li>
                    <p className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                      Accept Request Or Deny Request
                    </p>
                  </li>
                  <li>
                    <p className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                      Accept Request Or Deny Request
                    </p>
                  </li>
                  <li>
                    <p className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                      Accept Request Or Deny Request
                    </p>
                  </li>
                  <li>
                    <p className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                      Sign out
                    </p>
                  </li>
                </ul>
              </div> */}
              </div>
            </div>
          </div>
        </Link>

        <Link to="/BoxesRequests">
          <div className="hover:bg-white/10 transition duration-150 ease-linear rounded-lg py-3 px-2 group">
            <div
              // data-dropdown-toggle="dropdown"
              id="dropdownDefaultButton"
              className="relative flex hover:cursor-pointer flex-col space-y-2 md:flex-row md:space-y-0 space-x-2 items-center"
            >
              <div>
                <BsInboxes
                  size={30}
                  className="w-6 h-6 group-hover:text-indigo-400"
                />
              </div>
              <div>
                <p className="font-bold hover:cursor-pointer text-base lg:text-lg text-slate-200 leading-4 group-hover:text-indigo-400">
                  Requests
                </p>
                <p className="text-slate-400 text-sm hidden md:block">
                  Check boxes Requests
                </p>
                {/* <div
                id="dropdown"
                className="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700"
              >
                <ul
                  className="py-2 text-sm text-gray-700 dark:text-gray-200"
                  aria-labelledby="dropdownDefaultButton"
                >
                  <li>
                    <p className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                      Accept Request Or Deny Request
                    </p>
                  </li>
                  <li>
                    <p className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                      Accept Request Or Deny Request
                    </p>
                  </li>
                  <li>
                    <p className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                      Accept Request Or Deny Request
                    </p>
                  </li>
                  <li>
                    <p className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                      Sign out
                    </p>
                  </li>
                </ul>
              </div> */}
              </div>
            </div>
          </div>
        </Link>
        
          <Link to="/UserSettings">
            <div className="hover:bg-white/10 transition duration-150 ease-linear rounded-lg py-3 px-2 group">
              <div
                // data-dropdown-toggle="dropdown"
                id="dropdownDefaultButton"
                className="relative flex hover:cursor-pointer flex-col space-y-2 md:flex-row md:space-y-0 space-x-2 items-center"
              >
                <div>
                  <BsGear
                    size={30}
                    className="w-6 h-6 group-hover:text-indigo-400"
                  />
                </div>
                <div>
                  <p className="font-bold hover:cursor-pointer text-base lg:text-lg text-slate-200 leading-4 group-hover:text-indigo-400">
                    Settings
                  </p>
                  <p className="text-slate-400 text-sm hidden md:block">
                    Update Email/Number
                  </p>
                </div>
              </div>
            </div>
          </Link>
        <div className="h-[200px] w-full"></div>
      </div>
    </div>
  );
};

export default Profile;
